var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.09 43-.09-5.3c10-.06 22.63-.32 33.11 16.83a.48.48 0 0 0 .89-.32c-5.88-33.12-28.41-35.34-34.33-35.29l-.12-5.51a2 2 0 0 0 -3.25-1.5l-16.8 13.84a3.62 3.62 0 0 0 .11 5.73l17.39 13.13a2 2 0 0 0 3.09-1.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3ee87482.svg";
export { ForwardRef as ReactComponent };